import React from "react";
import { Divider, Grid } from "@mui/material";
import { useTranslations } from "next-intl";
import styled from "@emotion/styled";
import WsButtonWhatsapp from "@components/ws-button-whatsapp";
import WsButtonPhone from "@components/ws-button-phone";
import WsButtonMail from "@components/ws-button-mail";

interface ContactGroupProps {
  phone: string;
  whatsapp: string;
  email: string;
  blockWhatsapp?: boolean;
  blockPhone?: boolean;
  blockEmail?: boolean;
  wsClick: () => void;
  phoneClick: () => void;
  emailClick: () => void;
}

const WsContactGroup = (props: ContactGroupProps) => {
  const translation = useTranslations("property");

  const handleClickWhatsapp = (msg?: string) => {
    props.wsClick();
    if (props.blockWhatsapp) return;
    window.open(`https://wa.me/${props.whatsapp}?text=${msg}`, "_blank");
  };

  const handleClickPhone = () => {
    props.phoneClick();
    if (props.blockPhone) return;
    window.open(`tel:${props.phone}`, "_blank");
  };

  const handleClickEmail = () => {
    props.emailClick();
    if (props.blockEmail) return;
    window.open(`mailto:${props.email}`, "_blank");
  };

  return (
    <Grid container spacing={1} alignItems="center" justifyContent="center">
      <Grid item xs={12} mb={1} textAlign="center">
        <DividerContact />
        <MessageContact>{translation("contact")}</MessageContact>
        <DividerContact />
      </Grid>

      {props.whatsapp && (
        <Grid item xs={12}>
          <WsButtonWhatsapp
            onClick={handleClickWhatsapp}
            phone={props.whatsapp}
          />
        </Grid>
      )}
      {props.phone && (
        <Grid item xs={12}>
          <WsButtonPhone phone={props.phone} onClick={handleClickPhone} />
        </Grid>
      )}
      {props.email && (
        <Grid item xs={12}>
          <WsButtonMail
            onClick={handleClickEmail}
            email={props.email}
            label={translation("sendMessage")}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default WsContactGroup;

const MessageContact = styled.p`
  font-size: 1rem;
  font-weight: 600;
  color: black;
  margin: 10px auto;
  color: var(--color-brand-blue-main);
`;

const DividerContact = styled(Divider)`
  height: 1px;
  display: block;
  width: 100%;
  background-color: #e0e0e0;
`;
